import { Injectable } from '@angular/core'
import { first, map, Observable } from 'rxjs'
import { SeFeApiService } from 'se-fe-api'
import { CentralServiceResources as cs } from 'se-resource-types'

@Injectable({
  providedIn: 'root'
})
export class HouseholdGuardianInviteAdminSuggestionsService {
  private endpoint = 'v3/households/guardian_invite_admin_suggestions'

  constructor(
    private api: SeFeApiService
  ) {
      // noop
  }

  public create(
    access: string,
    to: string,
    persona_id: number,
    initiator: string,
    invitee: string): Observable<cs.Households.PersonaGuardianInvite> {
      return this.api.post<cs.Households.PersonaGuardianInvite>(this.endpoint, { access, to, persona_id, initiator, invitee}).pipe(
        map(response => response.result)
      )
  }

  public resend(id: string | number): Observable<cs.Households.PersonaGuardianInvite> {
    return this.api.get<cs.Households.PersonaGuardianInvite>(`${this.endpoint}/${id}/resend_invite`).pipe(
      first(),
      map(response => response.result)
    )
  }

}
